module.exports = __webpack_public_path__ + "img/2555c27.jpg";